import React, { useEffect, useState } from "react";
import { Table, Button, Empty, Grid } from "antd";
import {
  LoadingOutlined,
  BellOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { colors } from "../../core/theme";
import SendNotification from "../Modals/SendNotification";
import { get_language, translate } from "../../locale";
import _ from "lodash";
import DashServices from "../../services/DashServices";
import { TableHelper } from "../../helpers/TableHelper";
import moment from "moment";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const { useBreakpoint } = Grid;

const OutRangeSelfMeasurements = ({ selectedData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);
  const measureTypes = {
    sistolico: "Presión Sistólica",
    diastolico: "Presión Diastólica",
    fc: "Frecuencia Cardíaca",
    peso: "Peso",
    "diff-peso": "Aumento de peso",
    diabetes: "Glucemia",
    insulina: "Insulina",
    alimentos: "Alimentos",
    so2: "Saturación O2",
    temperatura: "Temperatura",
    fr: "Frecuencia Respiratoria",
  };

  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const screens = useBreakpoint();

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          >
            <BellOutlined className="text-black" />
          </Button>
        </div>
      ),
      fixed: "left",
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      align: "center",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.surname}
        </a>
      ),
      sorter: { multiple: 1 },
      fixed: "left",
    },
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      align: "center",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </a>
      ),
      sorter: { multiple: 2 },
    },
    {
      title: "Fecha",
      dataIndex: "latest_date",
      key: "latest_date",
      align: "center",

      render: (_, record) => {
        if (record.latest_date === null) {
          return "-";
        }
        return moment(record.latest_date)
          .tz(moment.tz.guess())
          .format(
            get_language === "en" ? "MM/DD/YYYY hh:mm a" : "DD/MM/YYYY HH:mm"
          );
      },
      sorter: { multiple: 3 },
    },
    {
      title: "Fuera de rango",
      dataIndex: "out_of_range",
      key: "out_of_range",
      align: "center",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <div className="flex space-x-2 items-center">
            <span>{record.out_of_range.danger}</span>{" "}
            <InfoCircleOutlined style={{ color: colors.custom_red }} />
          </div>
          <div className="flex space-x-2 items-center">
            <span>{record.out_of_range.warning}</span>{" "}
            <InfoCircleOutlined style={{ color: colors.custom_yellow }} />
          </div>
        </div>
      ),
      sorter: { multiple: 4 },
    },
    {
      title: "Detalles",
      dataIndex: "out_of_range_details",
      key: "out_of_range_details",
      align: "center",
      render: (_, record) => (
        <div className="space-x-2 flex">
          {record.out_of_range.list_warning.length > 0 && (
            <ul className="list-none">
              {record.out_of_range.list_warning.map((warning, index) => (
                <li
                  key={index}
                  className="flex text-center justify-start gap-2"
                >
                  <InfoCircleOutlined
                    style={{
                      color: colors.custom_yellow,
                      alignSelf: "center",
                    }}
                  />
                  {measureTypes[warning.type]}
                </li>
              ))}
            </ul>
          )}
          {record.out_of_range.list_danger.length > 0 && (
            <ul className="list-none">
              {record.out_of_range.list_danger.map((danger, index) => (
                <li key={index} className="flex gap-2">
                  <InfoCircleOutlined
                    style={{ color: colors.custom_red, alignSelf: "center" }}
                  />

                  {measureTypes[danger.type]}
                </li>
              ))}
            </ul>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (selectedData) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [selectedData, JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      let response = await DashServices.OutRangeRPM(
        selectedData.period,
        selectedData.suscription,
        "",
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(
          response.data.data.map((i) => ({
            ...i,
            latest_date: i.out_of_range.latest_date
              ? i.out_of_range.latest_date
              : null,
          }))
        );
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSendNotification = (username) => {
    setSelecteUser(username);
    setShowNotification(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
    </>
  );
};

export default OutRangeSelfMeasurements;
